module.exports = __webpack_public_path__ + "static/img/detailTitle-yjs.5fe2b70.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/detailTitle-yjs.png
// module id = 825
// module chunks = 0